import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@mui/material'
import { ArrowUp } from '../../assets/img/icons'
import { AccordionOuterWrapper, HeadingWrapper, Heading, ShowOverlay } from './style'

import useLocalStorage from '../../hooks/useLocalStorage'

const AccordionWithArrow = ({ title, expandArrow, children, accordionstyle = 'default', expanded = true, showOverlay, onExpandChange = null, showArrow = true }) => {
  const titleKey = title.trim().replaceAll(' ', '').replaceAll('-', '')
  // const [expand, setExpand] = useLocalStorage(titleKey, isKeyAvailable)
  const [expand, setExpand] = useLocalStorage(titleKey, expanded)

  const onIconClickedFunc = () => {
    setExpand(!expand)
    if (isNaN(onExpandChange)) onExpandChange(!expand)
  }

  useEffect(() => {
    setExpand(expanded)
  }, [expanded])

  useEffect(() => {
    const ls_title = JSON.parse(localStorage.getItem(titleKey))
    const isKeyAvailable = localStorage.getItem(titleKey) ? ls_title : expanded
    setExpand(isKeyAvailable)
  }, [])

  return (
    <AccordionOuterWrapper className={`accordionWrapper expanded_${expand} exp_${expanded}`} accordionstyle={accordionstyle}>
      <HeadingWrapper className='heading' accordionstyle={accordionstyle}>
        <Heading accordionstyle={accordionstyle}>{title}</Heading>
        {showArrow && <IconButton onClick={onIconClickedFunc}>{ expandArrow || <ArrowUp />}</IconButton>}
      </HeadingWrapper>
      {showOverlay && <ShowOverlay />}
      {/* {(expand || expanded === null) && children} */}
      {/* {(expand && expanded) ? children : <>N/A</>} */}
      {(expand && expanded) && children}
      {/* {expand && children} */}
    </AccordionOuterWrapper>
  )
}

AccordionWithArrow.propTypes = {
  children: PropTypes.node,
  accordionstyle: PropTypes.string,
  title: PropTypes.string,
  expanded: PropTypes.bool,
  expandArrow: PropTypes.node,
  onExpandChange: PropTypes.func,
  showOverlay: PropTypes.bool,
  showArrow: PropTypes.bool
}

export default AccordionWithArrow
